import { render, staticRenderFns } from "./LocaleChooser.vue?vue&type=template&id=65ddc446"
import script from "./LocaleChooser.vue?vue&type=script&lang=js"
export * from "./LocaleChooser.vue?vue&type=script&lang=js"
import style0 from "./LocaleChooser.vue?vue&type=style&index=0&id=65ddc446&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports